<template lang="pug">
div
  app-divider(label="Cadastrante")
  div.pad5
    div(v-if="cadastrante.pessoa.tipo === 'PF'")
        p
          span.label CPF:
          span &nbsp {{cadastrante.pessoa.pessoaFisica.cpf}}
        p
          span.label Nome:
          span &nbsp {{cadastrante.pessoa.pessoaFisica.nome}}
        p
          span.label Matrícula:
          span &nbsp {{cadastrante.pessoa.pessoaFisica.matricula}}
    div(v-else)
      p
        span.label CNPJ:
        span &nbsp {{filterNull(cadastrante.pessoa.pessoaJuridica.cnpj)}}
      p
        span.label Razão Social:
        span &nbsp {{filterNull(cadastrante.pessoa.pessoaJuridica.razaoSocial)}}

    p
      span.label Telefone(s):
      span(v-for="item in cadastrante.pessoa.telefones") &nbsp {{ item }}
    p
      span.label E-mail:
      span &nbsp {{getEmail()}}
    p
      span.label Solicitação: &nbsp
      span(v-html="cadastrante.solicitacao")
    p
      span.label Ofício:
      app-resumo-documentos(
        :documentos="[cadastrante.oficio]",
        codigoCadastro="oficio",
        :idCadastro="idCadastro"
      )

    p
    app-resumo-endereco(:endereco="cadastrante.pessoa.endereco")

    app-resumo-documentos(:documentos="cadastrante.documentos", codigoCadastro="cadastrante", :idCadastro="idCadastro")
</template>
<script>
import AppDivider from '../AppDivider'
import AppResumoEndereco from './AppResumoEndereco'
import AppResumoDocumentos from './AppResumoDocumentos'

export default {
  components: {
    AppDivider,
    AppResumoEndereco,
    AppResumoDocumentos
  },
  props: {
    cadastrante: {
      type: Object,
      required: true
    },
    idCadastro: {
      type: Number,
      required: true
    }
  },
  methods: {
    filterNull (atributo) {
      return atributo !== null ? atributo : '-'
    },
    getEmail () {
      return this.cadastrante.pessoa.email || '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoCadastranteAreasPatrimoniais.vue